// extracted by mini-css-extract-plugin
export default {"container":"q0-z","list":"r0-z"};